import isFunction from "lodash/isFunction";
import {FaChevronCircleRight} from "react-icons/fa";

import Button from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {shortDateTimeUser} from "@/lib/format.tsx";
import {Alert} from "@/lib/types/alerting.ts";

interface AlertDetailsBasicProps {
  alert: Alert;
  className?: string;
  onAlertDataRequest?: (id: number) => Promise<void>;
}

export const DownAlert = ({alert, className, onAlertDataRequest}: AlertDetailsBasicProps) => {
  const {user} = useCurrentUserContext();
  const monSrv = alert.monitoring_server?.location ? alert.monitoring_server : null;
  const withAlertExtraData = isFunction(onAlertDataRequest);
  return (
    <div key={alert.id} className={className}>
      <h5 className="mb-2">
        <strong>{monSrv?.location || "Check Result"}</strong>
      </h5>
      <p className="fs-7 text-muted mb-1">{shortDateTimeUser(alert.created_at, user!)}</p>
      {monSrv && (
        <div className="d-flex justify-content-between align-items-center mb-2">
          <p className="fs-7 text-muted me-3 mb-0">
            <em>{monSrv.name || ""}</em>
          </p>
          <p className="d-none d-md-block font-13 font-monospace text-muted text-prewrap mb-0">
            {monSrv.address_ipv4 && `[${monSrv.address_ipv4}]`}&nbsp;
            {monSrv.address_ipv6 && `[${monSrv.address_ipv6}]`}
          </p>
        </div>
      )}
      <pre className="card card-body bg-light text-muted text-prewrap mb-0">{alert.output}</pre>
      {withAlertExtraData && (
        <Button variant="linkBlue" className="p-0" onClick={() => onAlertDataRequest(alert.id)}>
          <FaChevronCircleRight /> Root Cause Analysis
        </Button>
      )}
    </div>
  );
};
